import { Component, Input, OnInit } from '@angular/core'

@Component({
    selector: 'app-chat-content',
    templateUrl: './chat-content.component.html',
    styleUrls: ['./chat-content.component.css'],
})
export class ChatContentComponent implements OnInit {

    @Input() inputClass = ''
    @Input() type
    @Input() images = []
    @Input() pdfs = []
    @Input() videos = []
    @Input() note = ''
    @Input() content = ''
    @Input() isShow = true
    @Input() isQuoteMessge = false

    constructor() {
    }

    ngOnInit() {
    }

    disableModal(event) {
        if (event.target.tagName.toLowerCase() === 'a') {
            event.stopPropagation()
        }
    }

    get getQuoteContent() {
        if (this.images && this.images.length > 0 && this.images[0] !== 'init') {
            return 'Image'
        }
        if (this.videos && this.videos.length > 0 && this.videos[0] !== 'init') {
            return 'Video'
        }
        if (this.pdfs && this.pdfs.length > 0 && this.pdfs[0] !== 'init') {
            return 'PDF'
        }
    }

    compactString(str: string) {
        if (str) {
            str = str.replace(/\s{2,}/g, ' ')
            const max = 50
            return str.length > max
                ? str.substring(0, max) + '...'
                : str
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/commons/chat/chat-content/chat-content.component.ts